import Grid from "@mui/material/Grid2";
import { FormGroup, Input, Textarea } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import FormField from "components/cck/FormField";
import { Fragment, ReactNode } from "react";
import { CalculationMethodFormByTypeProps } from "@schemas/calculationmethods/schema";
import { AgreementTypeEnum } from "__generated__/graphql";

type FormValues = {
	agreements: {
		type?: AgreementTypeEnum;
		calculationMethod: {
			customUnit?: string;
			description?: string;
		}
	}[];
}

type FormField = {
	id: string;
	render: () => ReactNode;
}

const ManualCalculationMethodForm = ({ index, hiddenFields }: CalculationMethodFormByTypeProps) => {
	const { control, formState: { errors } } = useFormContext<FormValues>();

	const type = useWatch({ control, name: `agreements.${index}.type` });

	const ManualCalculationMethodFormFields: FormField[] = [
		{
			id: "calculationMethod.customUnit",
			render: () => type === AgreementTypeEnum.PostCalculation && (
				<Grid size={4}>
					<FormField errors={errors} name={`agreements.${index}.calculationMethod.customUnit`}>
						<FormGroup label={intl.formatMessage({ id: "POST_CALCULATION_CUSTOM_UNIT" })} overflow="hidden">
							<Controller
								name={`agreements.${index}.calculationMethod.customUnit`}
								control={control}
								render={({ field }) => (
									<Input
										{...field} />
								)} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
		{
			id: "calculationMethod.description",
			render: () => (
				<Grid size={8}>
					<FormField errors={errors} name={`agreements.${index}.calculationMethod.description`}>
						<FormGroup label={intl.formatMessage({ id: "MANUAL_TEXT" })} overflow="hidden">
							<Controller
								name={`agreements.${index}.calculationMethod.description`}
								control={control}
								render={({ field }) => (
									<Textarea
										{...field} />
								)} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
	];

	return (
		<Grid container spacing={2} size={12}>
			{ManualCalculationMethodFormFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</Grid>
	);
};

export default ManualCalculationMethodForm;
